import React, { useState } from "react";
import { Link } from "react-scroll";

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <nav className="bg-gray-800 text-white fixed w-full z-10 top-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <p className="text-lg font-bold">ANURAG GAIWAL</p>
          </div>
          <div className="hidden md:flex space-x-4">
            <Link to="home" smooth={true} duration={500} className="cursor-pointer px-3 py-2 rounded-md text-sm font-medium hover:bg-gray-700">Home</Link>
            <Link to="education" smooth={true} duration={500} className="cursor-pointer px-3 py-2 rounded-md text-sm font-medium hover:bg-gray-700">Education</Link>
            <Link to="work" smooth={true} duration={500} className="cursor-pointer px-3 py-2 rounded-md text-sm font-medium hover:bg-gray-700">Work Experience</Link>
            <Link to="projects" smooth={true} duration={500} className="cursor-pointer px-3 py-2 rounded-md text-sm font-medium hover:bg-gray-700">Projects</Link>
            <Link to="skills" smooth={true} duration={500} className="cursor-pointer px-3 py-2 rounded-md text-sm font-medium hover:bg-gray-700">Skills</Link>
            <Link to="contact" smooth={true} duration={500} className="cursor-pointer px-3 py-2 rounded-md text-sm font-medium hover:bg-gray-700">Contact</Link>
          </div>
          <div className="md:hidden">
            <button onClick={handleToggle} className="text-gray-300 hover:text-white focus:outline-none focus:text-white">
              <svg className="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      {isOpen && (
        <div className="md:hidden bg-gray-800">
          <Link to="home" smooth={true} duration={500} className="block px-3 py-2 rounded-md text-base font-medium hover:bg-gray-700" onClick={handleClose}>Home</Link>
          <Link to="education" smooth={true} duration={500} className="block px-3 py-2 rounded-md text-base font-medium hover:bg-gray-700" onClick={handleClose}>Education</Link>
          <Link to="work" smooth={true} duration={500} className="block px-3 py-2 rounded-md text-base font-medium hover:bg-gray-700" onClick={handleClose}>Work Experience</Link>
          <Link to="projects" smooth={true} duration={500} className="block px-3 py-2 rounded-md text-base font-medium hover:bg-gray-700" onClick={handleClose}>Projects</Link>
          <Link to="skills" smooth={true} duration={500} className="block px-3 py-2 rounded-md text-base font-medium hover:bg-gray-700" onClick={handleClose}>Skills</Link>
          <Link to="contact" smooth={true} duration={500} className="block px-3 py-2 rounded-md text-base font-medium hover:bg-gray-700" onClick={handleClose}>Contact</Link>
        </div>
      )}
    </nav>
  );
};

export default NavBar;
